import {
  RequestQueue,
  type AsyncTask,
} from "@shared/services/request-queue/RequestQueue";

/**
 * A singleton instance of RequestQueue specifically for basket operations.
 * Ensures all basket requests are processed through a single queue with controlled concurrency.
 */
export class BasketRequestQueue extends RequestQueue {
  private static instance: BasketRequestQueue;
  private currentKey = 1; // used to generate a unique key for each basket request

  /**
   * Private constructor to prevent direct instantiation.
   * Creates a RequestQueue with a concurrency of 1 to ensure sequential basket operations.
   */
  private constructor() {
    super(1);
  }

  // Wrap the add method to generate a unique key for each basket request
  public addBasketRequest<T>(task: AsyncTask<T>): Promise<T> {
    const key = `basket-request-${this.currentKey}`;
    this.currentKey += 1; // increment the key for the next request
    return super.add(key, task);
  }

  /**
   * Gets the singleton instance of BasketRequestQueue.
   * Creates the instance if it doesn't exist.
   * @returns {BasketRequestQueue} The singleton instance.
   */
  public static getInstance(): BasketRequestQueue {
    if (!BasketRequestQueue.instance) {
      BasketRequestQueue.instance = new BasketRequestQueue();
    }
    return BasketRequestQueue.instance;
  }
}
